import * as React from 'react';

import classes from './LoadingIndicator.scss';

type Props = {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

const LoadingIndicator: React.FC<Props> = ({ size = 'md', className }) => (
  <div
    className={[classes['container'], className].filter(Boolean).join(' ')}
    aria-busy
    aria-live="polite"
  >
    <span
      className={classes['spinner']}
      data-size={size}
      aria-hidden="true"
    />
  </div>
);

export default LoadingIndicator;
